import { gql } from '@apollo/client';

export const RESERVE_PACK_MUTATION = gql`
  mutation ReservePack($data: ReservePackInput!) {
    reservePack(data: $data)
  }
`;
